import axios from 'axios';
import { useContext } from 'react';
import {AuthContext} from './AuthProvider'



export default  axios.create({

    // baseURL: "http://localhost/movers/api/user/",
    baseURL: "https://ppimpl.com/api/user/",
   
})
